"use client";

import { useEffect, useState } from "react";
import {
  DIAGNOSIS_UNLOCK_STEP_PROGRESS_ACTIVE_MS,
  getDefaultStepProgressLabels,
  isStepProgressSequenceComplete,
} from "./diagnosisUnlockFourStep.contract";

/**
 * 步骤 progress 动画状态机（步数与文案由 `labels` 决定）。
 *
 * `activeIndex` 从 0 递增；当 `activeIndex === labels.length` 时触发 `onComplete`。
 */
export function useDiagnosisUnlockStepProgress(options: {
  labels: readonly string[];
  /** DEBUG / 样式调优：为 true 时不启动定时器 */
  paused?: boolean;
  stepDurationMs?: number;
  onComplete: () => void;
}): { activeIndex: number } {
  const { labels, paused = false, stepDurationMs, onComplete } = options;
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (labels.length === 0 || paused) {
      return;
    }

    if (isStepProgressSequenceComplete(labels, activeIndex)) {
      onComplete();
      return;
    }

    const timer = window.setTimeout(() => {
      setActiveIndex((prev) => prev + 1);
    }, stepDurationMs ?? DIAGNOSIS_UNLOCK_STEP_PROGRESS_ACTIVE_MS);

    return () => {
      window.clearTimeout(timer);
    };
  }, [activeIndex, labels, onComplete, paused, stepDurationMs]);

  return { activeIndex };
}

/** @deprecated 使用 {@link useDiagnosisUnlockStepProgress} */
export function useDiagnosisUnlockFourStepProgress(options: {
  enabled: boolean;
  paused?: boolean;
  stepDurationMs?: number;
  onComplete: () => void;
}): { activeIndex: number } {
  const { enabled, paused = false, stepDurationMs, onComplete } = options;

  return useDiagnosisUnlockStepProgress({
    labels: enabled ? [...getDefaultStepProgressLabels()] : [],
    paused: !enabled || paused,
    stepDurationMs,
    onComplete,
  });
}
